var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJ5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409,259.73c-88.41-51-231.28-51-319.12,0S2.55,393.54,91,444.58s231.28,51,319.12,0S497.45,310.78,409,259.73Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.08,364.65l-83.45-48.2L192,354.81a43.88,43.88,0,0,0-11.88-9.67c-23.76-13.72-62.15-13.72-85.76,0s-23.48,36,.28,49.67a71.48,71.48,0,0,0,16.25,6.71l-6.69,3.86a3,3,0,0,0,0,5.25l77.4,44.7a12.08,12.08,0,0,0,12.1,0L342.08,369.9A3,3,0,0,0,342.08,364.65Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.81,396c-7.2-4.16-18.84-4.16-26,0s-7.11,10.9.09,15.06,18.84,4.16,26,0S408,400.16,400.81,396Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Elements--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.94,82.92a83.23,83.23,0,0,1,18.65,14.25c12.21,12.18,18.7,24.76,20.53,40.05,1.74,14.44-3.56,24.78-7.72,35.38-2.85,7.24-5.23,15.44-4.43,25.27s7,18.23,9.63,28.45c3.27,12.59-3.31,17-11,18.87-5,1.19-12.13.76-15.82,4.17-3.43,3.15-5.09,8.52-6.45,13.75-2.72,10.4-3.88,23.78-12.75,27.65-5.13,2.24-12.07.61-19-3.19a58,58,0,0,1-7.24-4.71c-9.13-6.91-17.43-16.41-25.5-25.82-10.21-11.93-22.88-25.81-35.22-32.54a39.26,39.26,0,0,0-4.42-2.1c-13-5.22-24.92-5.51-37.06-6.94a54.63,54.63,0,0,1-19.93-6.14,47.91,47.91,0,0,1-14.37-12c-10.34-12.78-13.57-30.07-10.56-41.36,5.5-20.6,33.61-21.72,28-51.08-1-5.23-4.39-10.45-6.24-15.84a65.64,65.64,0,0,1-3.44-17c-.65-10.58,1.76-19.8,6.85-25.68,11.5-13.29,33-10.47,53.73.87a119.42,119.42,0,0,1,16.22,10.7C329.13,64,337.08,70.42,345,74.72a46.24,46.24,0,0,0,8.41,3.66c14.43,4.47,25.32-2.6,39-1.09A45.46,45.46,0,0,1,408.94,82.92Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.94,82.92a83.23,83.23,0,0,1,18.65,14.25c12.21,12.18,18.7,24.76,20.53,40.05,1.74,14.44-3.56,24.78-7.72,35.38-2.85,7.24-5.23,15.44-4.43,25.27s7,18.23,9.63,28.45c3.27,12.59-3.31,17-11,18.87-5,1.19-12.13.76-15.82,4.17-3.43,3.15-5.09,8.52-6.45,13.75-2.72,10.4-3.88,23.78-12.75,27.65-5.13,2.24-12.07.61-19-3.19a58,58,0,0,1-7.24-4.71c-9.13-6.91-17.43-16.41-25.5-25.82-10.21-11.93-22.88-25.81-35.22-32.54a39.26,39.26,0,0,0-4.42-2.1c-13-5.22-24.92-5.51-37.06-6.94a54.63,54.63,0,0,1-19.93-6.14,47.91,47.91,0,0,1-14.37-12c-10.34-12.78-13.57-30.07-10.56-41.36,5.5-20.6,33.61-21.72,28-51.08-1-5.23-4.39-10.45-6.24-15.84a65.64,65.64,0,0,1-3.44-17c-.65-10.58,1.76-19.8,6.85-25.68,11.5-13.29,33-10.47,53.73.87a119.42,119.42,0,0,1,16.22,10.7C329.13,64,337.08,70.42,345,74.72a46.24,46.24,0,0,0,8.41,3.66c14.43,4.47,25.32-2.6,39-1.09A45.46,45.46,0,0,1,408.94,82.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.05,64.47A33.9,33.9,0,0,0,368,71a19.79,19.79,0,0,0,7.8-3.09,11,11,0,0,0,4.6-6.85,7.67,7.67,0,0,0-2.83-7.5c-2.21-1.56-5.13-1.6-7.83-1.36s-5.47.68-8.06-.11a13.67,13.67,0,0,1-6.28-4.73c-1.69-2.05-3.12-4.32-5-6.24A19.92,19.92,0,0,0,335.94,35a11,11,0,0,0-5.69,1.43c-3.21,2-4.46,6.3-3.78,10C327.93,54.51,335.09,59.8,341.05,64.47Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.53,114.4c-.44,5.07-2.45,10.31-6.64,13.18-4.75,3.26-11.45,2.69-16.29-.43s-8-8.39-9.63-13.9c-2-6.5-2-14,1.77-19.62,4.07-6.16,14.16-9.18,20.34-4.38C245.4,94.93,249.32,105.35,248.53,114.4Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.68,71.34c2.33,1.35,5.09,2.5,7.64,1.65,2.76-.93,4.33-4.13,4-7-.74-6.14-9.34-11.85-15.39-9.87C386.3,58.91,394.26,68.77,398.68,71.34Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.57,75.73a9.39,9.39,0,0,1-.24-8.9,8.11,8.11,0,0,1,4.12-4.1,5.36,5.36,0,0,1,5.56.87,6.93,6.93,0,0,1,1.82,4.64c.2,3.08-.67,8-3.09,10.19S228,78,226.57,75.73Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.05,64.47A33.9,33.9,0,0,0,368,71a19.79,19.79,0,0,0,7.8-3.09,11,11,0,0,0,4.6-6.85,7.67,7.67,0,0,0-2.83-7.5c-2.21-1.56-5.13-1.6-7.83-1.36s-5.47.68-8.06-.11a13.67,13.67,0,0,1-6.28-4.73c-1.69-2.05-3.12-4.32-5-6.24A19.92,19.92,0,0,0,335.94,35a11,11,0,0,0-5.69,1.43c-3.21,2-4.46,6.3-3.78,10C327.93,54.51,335.09,59.8,341.05,64.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.53,114.4c-.44,5.07-2.45,10.31-6.64,13.18-4.75,3.26-11.45,2.69-16.29-.43s-8-8.39-9.63-13.9c-2-6.5-2-14,1.77-19.62,4.07-6.16,14.16-9.18,20.34-4.38C245.4,94.93,249.32,105.35,248.53,114.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.68,71.34c2.33,1.35,5.09,2.5,7.64,1.65,2.76-.93,4.33-4.13,4-7-.74-6.14-9.34-11.85-15.39-9.87C386.3,58.91,394.26,68.77,398.68,71.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.57,75.73a9.39,9.39,0,0,1-.24-8.9,8.11,8.11,0,0,1,4.12-4.1,5.36,5.36,0,0,1,5.56.87,6.93,6.93,0,0,1,1.82,4.64c.2,3.08-.67,8-3.09,10.19S228,78,226.57,75.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.25,82.67C326.73,74.86,314.2,70.13,302,70.45c-12.53.33-23.85,5.38-30.7,12.57-4.92,5.16-7.52,11.42-6.61,17.83,1.85,12.9,17.47,23.48,35.24,24.89a26.68,26.68,0,0,0,8.89-.5c2.81-.74,5.3-2.37,6-4.46s-.47-4.12,0-6.15c.93-3.81,6.72-5.73,10.94-8.15C335.24,101,337.77,90.48,332.25,82.67Zm-23.6,38.73c-.73,1-2.43,1.32-4,1.38a13.16,13.16,0,0,1-6.43-1.24c-3.57-1.87-4.2-7,1.13-7.78,4.32-.6,8.71,2.84,9.5,5.58A2.25,2.25,0,0,1,308.65,121.4Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.25,80.1C326.73,72.29,314.2,67.55,302,67.87c-12.53.34-23.85,5.38-30.7,12.57-4.92,5.16-7.52,11.43-6.61,17.84,1.85,12.9,17.47,23.47,35.24,24.89a26.68,26.68,0,0,0,8.89-.5c2.81-.75,5.3-2.37,6-4.47s-.47-4.12,0-6.14c.93-3.81,6.72-5.73,10.94-8.16C335.24,98.43,337.77,87.91,332.25,80.1Zm-23.6,38.73c-.73,1-2.43,1.31-4,1.37a13,13,0,0,1-6.43-1.24c-3.57-1.87-4.2-7,1.13-7.77,4.32-.61,8.71,2.84,9.5,5.57A2.27,2.27,0,0,1,308.65,118.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.68,101.8c0,.45.06.93.09,1.45a2.71,2.71,0,0,1-.16,1.32c-.44.93-1.84,1.74-1.72,2.82.13,1.25,2,1.27,3.27,1.1l6.51-.82a12.54,12.54,0,0,0,3.53-.78c1.05-.48,1.86-1.34,1.67-2.21s-1.31-1.54-2.47-1.88c-1.46-.44-3.09-.56-4.38-1.26-1-.54-1.39-1.36-2.24-2-1.31-.92-2.41-.37-3.33.49A2.24,2.24,0,0,0,275.68,101.8Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.52,91.29a4.31,4.31,0,0,0,4,2.38,8.16,8.16,0,0,0,2.74-.72l4.73-1.9a6.58,6.58,0,0,0,1.88-1c2.57-2.29-1.6-4.58-4.26-5.29a9.26,9.26,0,0,0-8.21,2.34A3.8,3.8,0,0,0,274.52,91.29Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.58,75.59c.94.61,1.28,1.63,2.37,2.1a14.1,14.1,0,0,0,3.32.41c2,.3,3.43,1.8,3.12,3.22s-2.33,2.54-4.33,2.39-3.69-1.4-5.74-1.65-4.1.43-5.9-.52c-1.35-.72-1.5-1.67-.84-2.72C286.74,77,290.37,73.49,293.58,75.59Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.89,84.13a8.1,8.1,0,0,0,6.35,1.55,14,14,0,0,0,5.52-2.59,6.67,6.67,0,0,0,1.84-1.58,1.48,1.48,0,0,0-.08-2c-1-1-3.35-1-4.83-1.34-1.32-.3-2.52-.85-3.85-1.14-2.94-.64-5.72,1.38-6.23,3.34A3.71,3.71,0,0,0,310.89,84.13Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.75,88.42a9.13,9.13,0,0,0-5.07,2.6,3.28,3.28,0,0,0-.23,4.34c.45.55,1.1,1,1.61,1.52a2,2,0,0,1,.73,1.78c-.31,1.17-2.43,2-2.13,3.11.17.64,1.07,1.08,2,1.14a7.31,7.31,0,0,0,2.63-.4c3.8-1.13,7.32-3,9.07-5.69a5.9,5.9,0,0,0-.52-7.42C323.14,87.56,319.35,87.88,316.75,88.42Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,95.54a12.21,12.21,0,0,0,4.76,2.11,8.75,8.75,0,0,0,3.05.5c1.54-.11,2.87-1.09,3-2.19S302.86,94,303,93s1.09-1.81,1.77-2.69,1-2.08,0-2.77a3.67,3.67,0,0,0-3.18-.09c-1.38.55-2.18,1.67-3.58,2.17-1.14.4-2.26,0-3.41.23A3.25,3.25,0,0,0,292.79,95.54Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.68,101.8c0,.45.06.93.09,1.45a2.71,2.71,0,0,1-.16,1.32c-.44.93-1.84,1.74-1.72,2.82.13,1.25,2,1.27,3.27,1.1l6.51-.82a12.54,12.54,0,0,0,3.53-.78c1.05-.48,1.86-1.34,1.67-2.21s-1.31-1.54-2.47-1.88c-1.46-.44-3.09-.56-4.38-1.26-1-.54-1.39-1.36-2.24-2-1.31-.92-2.41-.37-3.33.49A2.24,2.24,0,0,0,275.68,101.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.52,91.29a4.31,4.31,0,0,0,4,2.38,8.16,8.16,0,0,0,2.74-.72l4.73-1.9a6.58,6.58,0,0,0,1.88-1c2.57-2.29-1.6-4.58-4.26-5.29a9.26,9.26,0,0,0-8.21,2.34A3.8,3.8,0,0,0,274.52,91.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.58,75.59c.94.61,1.28,1.63,2.37,2.1a14.1,14.1,0,0,0,3.32.41c2,.3,3.43,1.8,3.12,3.22s-2.33,2.54-4.33,2.39-3.69-1.4-5.74-1.65-4.1.43-5.9-.52c-1.35-.72-1.5-1.67-.84-2.72C286.74,77,290.37,73.49,293.58,75.59Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.89,84.13a8.1,8.1,0,0,0,6.35,1.55,14,14,0,0,0,5.52-2.59,6.67,6.67,0,0,0,1.84-1.58,1.48,1.48,0,0,0-.08-2c-1-1-3.35-1-4.83-1.34-1.32-.3-2.52-.85-3.85-1.14-2.94-.64-5.72,1.38-6.23,3.34A3.71,3.71,0,0,0,310.89,84.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.75,88.42a9.13,9.13,0,0,0-5.07,2.6,3.28,3.28,0,0,0-.23,4.34c.45.55,1.1,1,1.61,1.52a2,2,0,0,1,.73,1.78c-.31,1.17-2.43,2-2.13,3.11.17.64,1.07,1.08,2,1.14a7.31,7.31,0,0,0,2.63-.4c3.8-1.13,7.32-3,9.07-5.69a5.9,5.9,0,0,0-.52-7.42C323.14,87.56,319.35,87.88,316.75,88.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.25,80.1C326.73,72.29,314.2,67.55,302,67.87c-12.53.34-23.85,5.38-30.7,12.57-4.6,4.83-7.18,10.62-6.74,16.6a18,18,0,0,0,.13,3.81c1.85,12.9,17.47,23.48,35.24,24.89a26.68,26.68,0,0,0,8.89-.5c2.81-.74,5.3-2.37,6-4.46a6.89,6.89,0,0,0,.08-2.93,9.41,9.41,0,0,0-.07-3.13.28.28,0,0,1,0-.09c.93-3.81,6.72-5.73,10.94-8.15,6.68-3.83,9.92-10.13,9.37-16.25A15.21,15.21,0,0,0,332.25,80.1Zm-27.57,40.1a13,13,0,0,1-6.43-1.24,5.21,5.21,0,0,1-2.53-2.85c.47-1.14,1.63-2.06,3.66-2.35a9.66,9.66,0,0,1,9.29,5l0,0C307.92,119.79,306.22,120.14,304.68,120.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.52,70.19A7.78,7.78,0,0,1,300.1,67a12.94,12.94,0,0,1-2.23-8.07c0,1.43,1.67,2.71,3,3.13a36.07,36.07,0,0,1,4.16,1,5.35,5.35,0,0,1,2.78,2.87A6.06,6.06,0,0,1,307.52,70.19Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.52,70.19A7.78,7.78,0,0,1,300.1,67a12.94,12.94,0,0,1-2.23-8.07c0,1.43,1.67,2.71,3,3.13a36.07,36.07,0,0,1,4.16,1,5.35,5.35,0,0,1,2.78,2.87A6.06,6.06,0,0,1,307.52,70.19Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.84,103.52h0a.78.78,0,0,0-.14-1.09L309.35,69a1.78,1.78,0,0,0-2.51.32h0a1.77,1.77,0,0,0,.36,2.5l43.55,31.89A.79.79,0,0,0,351.84,103.52Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.84,103.52h0a.78.78,0,0,0-.14-1.09L309.35,69a1.78,1.78,0,0,0-2.51.32h0a1.77,1.77,0,0,0,.36,2.5l43.55,31.89A.79.79,0,0,0,351.84,103.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,102.43,309.35,69a1.78,1.78,0,0,0-1.36-.36,4.93,4.93,0,0,0-.15-2.68,5.35,5.35,0,0,0-2.78-2.87,36.07,36.07,0,0,0-4.16-1c-1.36-.42-3-1.7-3-3.13A12.94,12.94,0,0,0,300.1,67a8.06,8.06,0,0,0,6.38,3.32,1.76,1.76,0,0,0,.72,1.49l43.55,31.89a.79.79,0,0,0,1.09-.16A.78.78,0,0,0,351.7,102.43Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.43 203.82 395.73 227.08 395.64 257.88 355.35 234.62 355.43 203.82",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.35 234.62 355.43 203.82 351.71 201.67 351.61 236.79 395.63 262.2 395.64 257.88 355.35 234.62",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,191.72l-3.73,2.17-.13,45.47,53,30.62,3.74-2.16.12-45.48Zm44.69,66.16v4.32l-44-25.41.1-35.12,3.72,2.15,40.3,23.26Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,191.72l-3.73,2.17-.13,45.47,53,30.62,3.74-2.16.12-45.48Zm44.69,66.16v4.32l-44-25.41.1-35.12,3.72,2.15,40.3,23.26Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.22 193.89 350.95 191.72 403.99 222.34 400.25 224.51 347.22 193.89",
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.99 222.34 403.86 267.81 400.12 269.98 400.25 224.51 403.99 222.34",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.43 203.82 355.35 234.62 351.61 236.79 351.71 201.67 355.43 203.82",
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.64 257.88 395.63 262.2 351.61 236.79 355.35 234.62 395.64 257.88",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "368.24 215.51 357.25 224.17 357.22 232.62 393.77 253.72 393.8 245.27 386.83 231.43 380.58 236.29 382.79 243.16 379.58 237.06 368.24 215.51",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.24,219.77c-1.72-1-3.12-.19-3.12,1.78a6.82,6.82,0,0,0,3.1,5.38c1.72,1,3.12.2,3.13-1.78A6.89,6.89,0,0,0,380.24,219.77Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "324.54 146.34 324.49 164.92 324.54 146.34 324.54 146.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.25,152.2,316.07,129a2.16,2.16,0,0,0-2.13-.23h0l-4.85,2.82h0a2.07,2.07,0,0,0-1,2l-.07,25a6.69,6.69,0,0,0,3,5.26l40.18,23.2a2,2,0,0,0,2.29.11v0l4.79-2.77,0,0,0,0h0a2.14,2.14,0,0,0,.86-1.93l.07-25A6.7,6.7,0,0,0,356.25,152.2Zm-31.76,12.72.05-18.58h0l14,17.38Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.25,152.2,316.07,129a2.16,2.16,0,0,0-2.13-.23h0l-4.85,2.82h0a2.07,2.07,0,0,0-1,2l-.07,25a6.69,6.69,0,0,0,3,5.26l40.18,23.2a2,2,0,0,0,2.29.11v0l4.79-2.77,0,0,0,0h0a2.14,2.14,0,0,0,.86-1.93l.07-25A6.7,6.7,0,0,0,356.25,152.2Zm-31.76,12.72.05-18.58h0l14,17.38Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.54 146.34 324.54 146.34 324.49 164.92 338.52 163.72 324.54 146.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.25,152.2,316.07,129a2.16,2.16,0,0,0-2.13-.23h0l-4.85,2.82h0a2.19,2.19,0,0,1,2.07.25l40.18,23.2a6.21,6.21,0,0,1,2.2,2.36l4.94-2.85A6.17,6.17,0,0,0,356.25,152.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.51,157.42a6.14,6.14,0,0,1,.84,2.9l-.07,25a2.21,2.21,0,0,1-.77,1.85v0l4.79-2.77,0,0,0,0h0a2.14,2.14,0,0,0,.86-1.93l.07-25a6.06,6.06,0,0,0-.84-2.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.25,152.2,316.07,129a2.16,2.16,0,0,0-2.13-.23h0l-4.85,2.82h0a2.07,2.07,0,0,0-1,2l-.07,25a6.69,6.69,0,0,0,3,5.26l40.18,23.2a2,2,0,0,0,2.29.11v0l4.79-2.77,0,0,0,0h0a2.14,2.14,0,0,0,.86-1.93l.07-25A6.7,6.7,0,0,0,356.25,152.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.08,159.86c-6.91-16.91-20.5-27.36-30.36-23.34s-12.27,21-5.36,37.92,20.49,27.37,30.36,23.34S299,176.78,292.08,159.86Zm-17,9.51c-.71.29-1.7-.46-2.2-1.69s-.32-2.45.39-2.75,1.7.47,2.2,1.7S275.84,169.08,275.12,169.37Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.08,159.86c-6.91-16.91-20.5-27.36-30.36-23.34s-12.27,21-5.36,37.92,20.49,27.37,30.36,23.34S299,176.78,292.08,159.86Zm-17,9.51c-.71.29-1.7-.46-2.2-1.69s-.32-2.45.39-2.75,1.7.47,2.2,1.7S275.84,169.08,275.12,169.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,164c-3-7.38-8.93-11.94-13.23-10.18s-5.35,9.16-2.34,16.53,8.94,11.93,13.24,10.18S285,171.35,282,164Zm-6.88,5.39c-.71.29-1.7-.46-2.2-1.69s-.32-2.45.39-2.75,1.7.47,2.2,1.7S275.84,169.08,275.12,169.37Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282,164c-3-7.38-8.93-11.94-13.23-10.18s-5.35,9.16-2.34,16.53,8.94,11.93,13.24,10.18S285,171.35,282,164Zm-6.88,5.39c-.71.29-1.7-.46-2.2-1.69s-.32-2.45.39-2.75,1.7.47,2.2,1.7S275.84,169.08,275.12,169.37Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282,164c-3-7.38-8.93-11.94-13.23-10.18s-5.35,9.16-2.34,16.53,8.94,11.93,13.24,10.18S285,171.35,282,164Zm-6.88,5.39c-.71.29-1.7-.46-2.2-1.69s-.32-2.45.39-2.75,1.7.47,2.2,1.7S275.84,169.08,275.12,169.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.72,174l-.05,18.26a2.22,2.22,0,0,1-2.5,2.24,4.89,4.89,0,0,1-2.35-.67,4.73,4.73,0,0,1-2.11-2.41c-.58-1.69.47-3.06,2.34-3.05a4.72,4.72,0,0,1,2.34.67,5.16,5.16,0,0,1,1.19.93l0-16Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,216a2.21,2.21,0,0,1-2.5,2.23,5,5,0,0,1-4.46-3.08c-.58-1.69.47-3.05,2.35-3.05a5,5,0,0,1,2.34.67,5.38,5.38,0,0,1,1.18.93l0-11.57-9.8-1.62,0,13.11a2.2,2.2,0,0,1-2.5,2.23,5,5,0,0,1-4.46-3.07c-.58-1.69.47-3.06,2.35-3a4.89,4.89,0,0,1,2.35.67,5.53,5.53,0,0,1,1.17.92l.05-16,12,2v5Zm-1.05-14.86v-2.47l-9.8-1.61v2.43l9.81,1.65",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.05,185.78c2.21,1.28,1.06,6.84,4.32,9.93a4.27,4.27,0,0,1-.53-.24,7.38,7.38,0,0,1-2.61-3.73c-.58-1.45-1-2.79-1.5-3.09a.42.42,0,0,0-.42,0l0,15.17a2.22,2.22,0,0,1-2.5,2.24,4.77,4.77,0,0,1-2.35-.68,4.6,4.6,0,0,1-2.11-2.39c-.59-1.7.46-3.06,2.34-3.05a4.75,4.75,0,0,1,2.35.67,5.3,5.3,0,0,1,1.18.91l0-16,1.1.05A2,2,0,0,1,317.05,185.78Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.72,174l-.05,18.26a2.22,2.22,0,0,1-2.5,2.24,4.89,4.89,0,0,1-2.35-.67,4.73,4.73,0,0,1-2.11-2.41c-.58-1.69.47-3.06,2.34-3.05a4.72,4.72,0,0,1,2.34.67,5.16,5.16,0,0,1,1.19.93l0-16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,216a2.21,2.21,0,0,1-2.5,2.23,5,5,0,0,1-4.46-3.08c-.58-1.69.47-3.05,2.35-3.05a5,5,0,0,1,2.34.67,5.38,5.38,0,0,1,1.18.93l0-11.57-9.8-1.62,0,13.11a2.2,2.2,0,0,1-2.5,2.23,5,5,0,0,1-4.46-3.07c-.58-1.69.47-3.06,2.35-3a4.89,4.89,0,0,1,2.35.67,5.53,5.53,0,0,1,1.17.92l.05-16,12,2v5Zm-1.05-14.86v-2.47l-9.8-1.61v2.43l9.81,1.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.05,185.78c2.21,1.28,1.06,6.84,4.32,9.93a4.27,4.27,0,0,1-.53-.24,7.38,7.38,0,0,1-2.61-3.73c-.58-1.45-1-2.79-1.5-3.09a.42.42,0,0,0-.42,0l0,15.17a2.22,2.22,0,0,1-2.5,2.24,4.77,4.77,0,0,1-2.35-.68,4.6,4.6,0,0,1-2.11-2.39c-.59-1.7.46-3.06,2.34-3.05a4.75,4.75,0,0,1,2.35.67,5.3,5.3,0,0,1,1.18.91l0-16,1.1.05A2,2,0,0,1,317.05,185.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.42,108.16h0l0,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.83,102.82l.7.86C388.3,103.39,388.07,103.1,387.83,102.82Z",
    style: {
      fill: "#37474f"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387.79,102.86l-.07-.08-.06-.07-.05,0,.1-.07,0,0,.13.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.15,140.23h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.05,134c0-6.13-4.31-13.61-9.65-16.69-2.63-1.52-5-1.69-6.76-.74l-.19.11,0,0c-1.67,1-2.7,3.14-2.71,6.12,0,6.14,4.3,13.62,9.64,16.7,2.65,1.53,5.06,1.69,6.81.71h0l.05,0C361,139.18,362,137,362.05,134Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.05,134c0-6.13-4.31-13.61-9.65-16.69-2.63-1.52-5-1.69-6.76-.74l-.19.11,0,0c-1.67,1-2.7,3.14-2.71,6.12,0,6.14,4.3,13.62,9.64,16.7,2.65,1.53,5.06,1.69,6.81.71h0l.05,0C361,139.18,362,137,362.05,134Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.63,132a13.73,13.73,0,0,0-6.24-10.8c-1.7-1-3.24-1.09-4.38-.47l-.12.07h0c-1.08.67-1.75,2-1.76,4a13.77,13.77,0,0,0,6.24,10.81c1.72,1,3.27,1.09,4.41.46h0C357.93,135.38,358.63,134,358.63,132Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,121.54h0c2.9,3.6,4.85,8.32,4.84,12.44,0,3.06-1.09,5.2-2.83,6.21l6.55-3.86c-1.81-6-5.25-10.78-8.55-14.79Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,121.54h0c2.9,3.6,4.85,8.32,4.84,12.44,0,3.06-1.09,5.2-2.83,6.21l6.55-3.86c-1.81-6-5.25-10.78-8.55-14.79Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.8 182.38 408.49 184.37 408.49 184.37 411.8 182.38",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.5,171.78c-2.52-4.66-7.38-7.72-12.28-9.74s-10.11-3.32-14.79-5.82-8.94-6.5-10-11.7c-.82-4.06.45-8.22.81-12.35,1.05-11.9-4.22-19.88-9.43-26.2a18.45,18.45,0,0,0-5-4.36,8.39,8.39,0,0,0-5.55-1.31L352,112.84a8.15,8.15,0,0,1,5.81,1.24,18.49,18.49,0,0,1,5,4.37c5.21,6.32,10.48,14.29,9.43,26.2-.36,4.13-1.63,8.28-.81,12.35,1.06,5.19,5.32,9.21,10,11.7s9.89,3.8,14.79,5.82,9.82,5.18,12.34,9.85l3.31-2Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.5,171.78c-2.52-4.66-7.38-7.72-12.28-9.74s-10.11-3.32-14.79-5.82-8.94-6.5-10-11.7c-.82-4.06.45-8.22.81-12.35,1.05-11.9-4.22-19.88-9.43-26.2a18.45,18.45,0,0,0-5-4.36,8.39,8.39,0,0,0-5.55-1.31L352,112.84a8.15,8.15,0,0,1,5.81,1.24,18.49,18.49,0,0,1,5,4.37c5.21,6.32,10.48,14.29,9.43,26.2-.36,4.13-1.63,8.28-.81,12.35,1.06,5.19,5.32,9.21,10,11.7s9.89,3.8,14.79,5.82,9.82,5.18,12.34,9.85l3.31-2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.15,174.52c-4.9-2-10.11-3.33-14.79-5.82s-8.94-6.51-10-11.7c-.82-4.07.45-8.22.81-12.35,1.05-11.91-4.22-19.88-9.43-26.2a18.49,18.49,0,0,0-5-4.37,8.15,8.15,0,0,0-5.81-1.24l-3.75,2.2,1.75-1,.12.88a4.55,4.55,0,0,0-1.56.51l-.14.08-.29-.38-2.45,1.44c1.75-1,4.13-.78,6.76.74a17.75,17.75,0,0,1,4.81,4.25h0c3.3,4,6.74,8.8,8.55,14.79A30.73,30.73,0,0,1,367,148c-.36,4.13-1.63,8.28-.81,12.34,1.05,5.2,5.31,9.21,10,11.71s9.88,3.8,14.79,5.82,9.72,5,12.24,9.65l5.32-3.19C406,179.7,401.05,176.54,396.15,174.52ZM354.82,116a9.62,9.62,0,0,0-1.84-.79l.31-1a11.61,11.61,0,0,1,2,.87Zm15.6,26.25-1,0c0-.68-.07-1.38-.13-2.07l1-.1C370.35,140.82,370.4,141.54,370.42,142.25Zm-1.28,5.22c.05-.41.1-.82.13-1.22s.05-.57.07-.85l1,.06c0,.29,0,.58-.07.88s-.08.84-.13,1.26Zm.57,3.27c-.11.7-.21,1.39-.29,2.08l-1-.13q.14-1,.3-2.1Zm-.41-15.89c.19.68.36,1.38.5,2.08l-1,.21c-.14-.68-.3-1.36-.49-2Zm-10.47-15.71a17.68,17.68,0,0,0-1.49-1.4l.66-.8c.54.46,1.07,1,1.58,1.49Zm3.3,4c-.42-.57-.85-1.12-1.28-1.66l.81-.65c.44.55.87,1.11,1.3,1.69Zm2.9,4.33c-.36-.6-.72-1.19-1.1-1.77l.86-.56c.39.59.77,1.19,1.13,1.81Zm1.45,2.76.94-.44c.3.64.58,1.3.85,2l-1,.38C367.05,131.53,366.77,130.89,366.48,130.27Zm1.71,25.65h1a14.4,14.4,0,0,0,.16,2l-1,.15A14.92,14.92,0,0,1,368.19,155.92Zm2.05,7.28a14.3,14.3,0,0,1-1-1.95l.95-.4a15.41,15.41,0,0,0,.92,1.81Zm3.48,4.13c-.54-.49-1.06-1-1.53-1.52l.77-.69c.45.49.94,1,1.45,1.44Zm4.39,3.12c-.63-.35-1.25-.73-1.83-1.13l.58-.85c.56.38,1.15.74,1.76,1.09Zm4.83,2.28c-.66-.27-1.31-.54-2-.83l.42-1c.64.29,1.28.56,1.92.82Zm5,1.82-2-.7.35-1,2,.71Zm4.94,1.8c-.65-.26-1.3-.5-2-.74l.36-1c.66.24,1.33.49,2,.75Zm4.72,2.2c-.61-.33-1.22-.65-1.85-1l.45-.93c.64.3,1.28.63,1.9,1Zm4.24,2.94c-.5-.44-1-.87-1.61-1.28l.6-.84c.59.43,1.17.88,1.69,1.34Zm3.33,3.86a15.66,15.66,0,0,0-1.18-1.66l.8-.66a16.43,16.43,0,0,1,1.26,1.78Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.71,159.46c-4.91-2-10.11-3.32-14.79-5.82s-8.95-6.5-10-11.7c-.82-4.06.45-8.22.81-12.35,1-11.28-4.22-19.68-9.2-25.91l-.7-.86-.13-.15a17.13,17.13,0,0,0-4.27-3.61c-2.74-1.59-5.21-1.68-7-.59v0l-3.15,1.85a8.39,8.39,0,0,1,5.55,1.31,18.45,18.45,0,0,1,5,4.36c5.21,6.32,10.48,14.3,9.43,26.2-.36,4.13-1.63,8.29-.81,12.35,1.06,5.2,5.32,9.21,10,11.7s9.89,3.8,14.79,5.82,9.76,5.08,12.28,9.74h0l4.45-2.66C431.43,164.45,426.61,161.48,421.71,159.46Zm-41-59.1a10.3,10.3,0,0,0-1.84-.79l.31-1a11.61,11.61,0,0,1,2,.87Zm4,3.14a19.48,19.48,0,0,0-1.49-1.4l.66-.79a19.81,19.81,0,0,1,1.58,1.48Zm11.59,23.11-1,0c0-.69-.07-1.39-.13-2.07l1-.11C396.28,125.18,396.33,125.9,396.35,126.61Zm-1.28,5.22c.05-.41.1-.81.13-1.22s.05-.57.07-.85l1,.07c0,.28,0,.58-.07.87s-.08.84-.13,1.26Zm.57,3.27c-.11.7-.21,1.39-.29,2.08l-1-.12c.09-.71.19-1.41.3-2.11Zm-.41-15.89c.19.68.36,1.38.5,2.08l-1,.21c-.14-.68-.3-1.36-.49-2Zm-7.17-11.67c-.42-.57-.85-1.12-1.28-1.66l.81-.64c.44.54.87,1.11,1.3,1.68Zm2.9,4.33c-.36-.6-.72-1.19-1.1-1.77l.86-.56c.39.59.77,1.19,1.13,1.81Zm2.28,4.67c-.26-.65-.54-1.29-.83-1.91l.94-.44c.3.64.58,1.3.85,2Zm.88,23.74h1a14.4,14.4,0,0,0,.16,2l-1,.15A14.92,14.92,0,0,1,394.12,140.28Zm2.05,7.28a14.3,14.3,0,0,1-1-1.95l.95-.39a14.54,14.54,0,0,0,.92,1.8Zm3.49,4.14a20.24,20.24,0,0,1-1.54-1.53l.77-.69c.45.49.94,1,1.46,1.45Zm4.38,3.12c-.63-.36-1.25-.74-1.83-1.14l.58-.85c.56.38,1.15.74,1.75,1.09Zm4.83,2.27c-.66-.27-1.31-.54-2-.83l.42-.94,1.92.81Zm5,1.82-2-.7.35-1,2,.7Zm4.94,1.8c-.65-.26-1.3-.5-2-.74l.36-1c.66.24,1.33.49,2,.75Zm4.72,2.2c-.61-.33-1.22-.65-1.85-.95l.45-.93c.64.31,1.28.63,1.9,1Zm4.24,2.94c-.5-.44-1-.87-1.61-1.28l.6-.84a21.19,21.19,0,0,1,1.69,1.34Zm2.15,2.2.8-.65a15.05,15.05,0,0,1,1.26,1.77l-.88.54A15.25,15.25,0,0,0,429.89,168.05Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.15,174.52c-4.9-2-10.11-3.33-14.79-5.82s-8.94-6.51-10-11.7c-.82-4.07.45-8.22.81-12.35,1.05-11.91-4.22-19.88-9.43-26.2a18.49,18.49,0,0,0-5-4.37,8.15,8.15,0,0,0-5.81-1.24l-3.75,2.2,1.75-1,.12.88a4.55,4.55,0,0,0-1.56.51l-.14.08-.29-.38-2.45,1.44c1.75-1,4.13-.78,6.76.74a17.75,17.75,0,0,1,4.81,4.25h0c3.3,4,6.74,8.8,8.55,14.79A30.73,30.73,0,0,1,367,148c-.36,4.13-1.63,8.28-.81,12.34,1.05,5.2,5.31,9.21,10,11.71s9.88,3.8,14.79,5.82,9.72,5,12.24,9.65l5.32-3.19C406,179.7,401.05,176.54,396.15,174.52ZM354.82,116a9.62,9.62,0,0,0-1.84-.79l.31-1a11.61,11.61,0,0,1,2,.87Zm15.6,26.25-1,0c0-.68-.07-1.38-.13-2.07l1-.1C370.35,140.82,370.4,141.54,370.42,142.25Zm-1.28,5.22c.05-.41.1-.82.13-1.22s.05-.57.07-.85l1,.06c0,.29,0,.58-.07.88s-.08.84-.13,1.26Zm.57,3.27c-.11.7-.21,1.39-.29,2.08l-1-.13q.14-1,.3-2.1Zm-.41-15.89c.19.68.36,1.38.5,2.08l-1,.21c-.14-.68-.3-1.36-.49-2Zm-10.47-15.71a17.68,17.68,0,0,0-1.49-1.4l.66-.8c.54.46,1.07,1,1.58,1.49Zm3.3,4c-.42-.57-.85-1.12-1.28-1.66l.81-.65c.44.55.87,1.11,1.3,1.69Zm2.9,4.33c-.36-.6-.72-1.19-1.1-1.77l.86-.56c.39.59.77,1.19,1.13,1.81Zm1.45,2.76.94-.44c.3.64.58,1.3.85,2l-1,.38C367.05,131.53,366.77,130.89,366.48,130.27Zm1.71,25.65h1a14.4,14.4,0,0,0,.16,2l-1,.15A14.92,14.92,0,0,1,368.19,155.92Zm2.05,7.28a14.3,14.3,0,0,1-1-1.95l.95-.4a15.41,15.41,0,0,0,.92,1.81Zm3.48,4.13c-.54-.49-1.06-1-1.53-1.52l.77-.69c.45.49.94,1,1.45,1.44Zm4.39,3.12c-.63-.35-1.25-.73-1.83-1.13l.58-.85c.56.38,1.15.74,1.76,1.09Zm4.83,2.28c-.66-.27-1.31-.54-2-.83l.42-1c.64.29,1.28.56,1.92.82Zm5,1.82-2-.7.35-1,2,.71Zm4.94,1.8c-.65-.26-1.3-.5-2-.74l.36-1c.66.24,1.33.49,2,.75Zm4.72,2.2c-.61-.33-1.22-.65-1.85-1l.45-.93c.64.3,1.28.63,1.9,1Zm4.24,2.94c-.5-.44-1-.87-1.61-1.28l.6-.84c.59.43,1.17.88,1.69,1.34Zm3.33,3.86a15.66,15.66,0,0,0-1.18-1.66l.8-.66a16.43,16.43,0,0,1,1.26,1.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.34,117.74a17.68,17.68,0,0,1,1.49,1.4l.75-.71c-.51-.53-1-1-1.58-1.49Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.85,121.52c.43.54.86,1.09,1.28,1.66l.83-.62c-.43-.58-.86-1.14-1.3-1.69Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.42,129.83l-.94.44c.29.62.57,1.26.83,1.91l1-.38C368,131.13,367.72,130.47,367.42,129.83Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,125.74c.38.58.74,1.17,1.1,1.77l.89-.52c-.36-.62-.74-1.22-1.13-1.81Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,115.21a9.62,9.62,0,0,1,1.84.79l.49-.91a11.61,11.61,0,0,0-2-.87Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.52,115.41a4.55,4.55,0,0,1,1.56-.51L350,114l-1.75,1-.12.07h0l.29.38Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.35,114.19l-.94.44c.29.62.57,1.26.83,1.91l1-.38C393.93,115.49,393.65,114.83,393.35,114.19Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.86,110.1c.38.58.74,1.17,1.1,1.77l.89-.52c-.36-.62-.74-1.22-1.13-1.81Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.78,105.88c.43.54.86,1.09,1.28,1.66l.83-.62c-.43-.57-.86-1.14-1.3-1.68Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.91,99.57a10.3,10.3,0,0,1,1.84.79l.49-.91a11.61,11.61,0,0,0-2-.87Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.27,102.1a19.48,19.48,0,0,1,1.49,1.4l.75-.71a19.81,19.81,0,0,0-1.58-1.48Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.34,117.74a17.68,17.68,0,0,1,1.49,1.4l.75-.71c-.51-.53-1-1-1.58-1.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360.85,121.52c.43.54.86,1.09,1.28,1.66l.83-.62c-.43-.58-.86-1.14-1.3-1.69Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M367.42,129.83l-.94.44c.29.62.57,1.26.83,1.91l1-.38C368,131.13,367.72,130.47,367.42,129.83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M363.93,125.74c.38.58.74,1.17,1.1,1.77l.89-.52c-.36-.62-.74-1.22-1.13-1.81Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M353,115.21a9.62,9.62,0,0,1,1.84.79l.49-.91a11.61,11.61,0,0,0-2-.87Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M348.52,115.41a4.55,4.55,0,0,1,1.56-.51L350,114l-1.75,1-.12.07h0l.29.38Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M393.35,114.19l-.94.44c.29.62.57,1.26.83,1.91l1-.38C393.93,115.49,393.65,114.83,393.35,114.19Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M389.86,110.1c.38.58.74,1.17,1.1,1.77l.89-.52c-.36-.62-.74-1.22-1.13-1.81Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M386.78,105.88c.43.54.86,1.09,1.28,1.66l.83-.62c-.43-.57-.86-1.14-1.3-1.68Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M378.91,99.57a10.3,10.3,0,0,1,1.84.79l.49-.91a11.61,11.61,0,0,0-2-.87Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M383.27,102.1a19.48,19.48,0,0,1,1.49,1.4l.75-.71a19.81,19.81,0,0,0-1.58-1.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M421.71,159.46c-4.91-2-10.11-3.32-14.79-5.82s-8.95-6.5-10-11.7c-.82-4.06.45-8.22.81-12.35,1-11.28-4.22-19.68-9.2-25.91l-.7-.86-.13-.15a17.13,17.13,0,0,0-4.27-3.61c-2.74-1.59-5.21-1.68-7-.59v0l-3.15,1.85a8.39,8.39,0,0,1,5.55,1.31,18.45,18.45,0,0,1,5,4.36c5.21,6.32,10.48,14.3,9.43,26.2-.36,4.13-1.63,8.29-.81,12.35,1.06,5.2,5.32,9.21,10,11.7s9.89,3.8,14.79,5.82,9.76,5.08,12.28,9.74h0l4.45-2.66C431.43,164.45,426.61,161.48,421.71,159.46Zm-41-59.1a10.3,10.3,0,0,0-1.84-.79l.31-1a11.61,11.61,0,0,1,2,.87Zm4,3.14a19.48,19.48,0,0,0-1.49-1.4l.66-.79a19.81,19.81,0,0,1,1.58,1.48Zm11.59,23.11-1,0c0-.69-.07-1.39-.13-2.07l1-.11C396.28,125.18,396.33,125.9,396.35,126.61Zm-1.28,5.22c.05-.41.1-.81.13-1.22s.05-.57.07-.85l1,.07c0,.28,0,.58-.07.87s-.08.84-.13,1.26Zm.57,3.27c-.11.7-.21,1.39-.29,2.08l-1-.12c.09-.71.19-1.41.3-2.11Zm-.41-15.89c.19.68.36,1.38.5,2.08l-1,.21c-.14-.68-.3-1.36-.49-2Zm-7.17-11.67c-.42-.57-.85-1.12-1.28-1.66l.81-.64c.44.54.87,1.11,1.3,1.68Zm2.9,4.33c-.36-.6-.72-1.19-1.1-1.77l.86-.56c.39.59.77,1.19,1.13,1.81Zm2.28,4.67c-.26-.65-.54-1.29-.83-1.91l.94-.44c.3.64.58,1.3.85,2Zm.88,23.74h1a14.4,14.4,0,0,0,.16,2l-1,.15A14.92,14.92,0,0,1,394.12,140.28Zm2.05,7.28a14.3,14.3,0,0,1-1-1.95l.95-.39a14.54,14.54,0,0,0,.92,1.8Zm3.49,4.14a20.24,20.24,0,0,1-1.54-1.53l.77-.69c.45.49.94,1,1.46,1.45Zm4.38,3.12c-.63-.36-1.25-.74-1.83-1.14l.58-.85c.56.38,1.15.74,1.75,1.09Zm4.83,2.27c-.66-.27-1.31-.54-2-.83l.42-.94,1.92.81Zm5,1.82-2-.7.35-1,2,.7Zm4.94,1.8c-.65-.26-1.3-.5-2-.74l.36-1c.66.24,1.33.49,2,.75Zm4.72,2.2c-.61-.33-1.22-.65-1.85-.95l.45-.93c.64.31,1.28.63,1.9,1Zm4.24,2.94c-.5-.44-1-.87-1.61-1.28l.6-.84a21.19,21.19,0,0,1,1.69,1.34Zm2.15,2.2.8-.65a15.05,15.05,0,0,1,1.26,1.77l-.88.54A15.25,15.25,0,0,0,429.89,168.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.71,135.62c.19-1.26.37-2.44.48-3.63a28.93,28.93,0,0,0-1.52-12.44l-17.56,10.13a32.72,32.72,0,0,1,2.12,15.15c-.11,1.32-.32,2.63-.51,3.89-.15,1-.3,1.95-.41,2.89l16.79-9.69A37.37,37.37,0,0,1,390.71,135.62Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.21,107.28a16.64,16.64,0,0,0-4.41-3.89,7.32,7.32,0,0,0-3.51-1.11l-.31,0-16.14,9.48q.48.24,1,.51a20.56,20.56,0,0,1,5.53,4.84,50.26,50.26,0,0,1,6.83,10.34l17.6-10.16A45.06,45.06,0,0,0,382.21,107.28Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.46,158.05c-3.52-1.87-9.62-6.06-11-13.12,0-.13,0-.26-.07-.39l-17.17,9.92a11.66,11.66,0,0,0,.22,2.13c.79,3.94,4.05,7.69,8.94,10.29a43.55,43.55,0,0,0,5.27,2.31l16.85-9.73C403.44,159,402.44,158.57,401.46,158.05Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.43,164c-1.78-.73-3.67-1.39-5.49-2-1.21-.42-2.44-.86-3.67-1.32l-16.73,9.65.7.25c1.87.65,3.81,1.33,5.7,2.11,3.92,1.62,9,4.43,12.23,8.95l17.45-10.46C424.5,168.27,421.09,165.87,416.43,164Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.71,159.46c-4.91-2-10.11-3.32-14.79-5.82s-8.95-6.5-10-11.7c-.82-4.06.45-8.22.81-12.35,1-11.28-4.22-19.68-9.2-25.91l-.7-.86-.13-.15a17.13,17.13,0,0,0-4.27-3.61c-2.74-1.59-5.21-1.68-7-.59v0l-3.15,1.85L352,112.84l-3.75,2.2-.12.07-2.45,1.44c1.75-1,4.13-.78,6.76.74a17.75,17.75,0,0,1,4.81,4.25h0c3.3,4,6.74,8.8,8.55,14.79A30.73,30.73,0,0,1,367,148c-.36,4.13-1.63,8.28-.81,12.34,1.05,5.2,5.31,9.21,10,11.71s9.88,3.8,14.79,5.82,9.72,5,12.24,9.65l5.32-3.19,3.31-2,17.7-10.6h0l4.45-2.66C431.43,164.45,426.61,161.48,421.71,159.46Zm5,4.27a21.19,21.19,0,0,1,1.69,1.34l-.68.78c-.5-.44-1-.87-1.61-1.28Zm-58-13.14,1,.15c-.11.7-.21,1.39-.29,2.08l-1-.13Q368.53,151.64,368.69,150.59Zm-.39-15.46,1-.28c.19.68.36,1.38.5,2.08l-1,.21C368.65,136.46,368.49,135.78,368.3,135.13Zm.84,12.34c.05-.41.1-.82.13-1.22s.05-.57.07-.85l1,.06c0,.29,0,.58-.07.88s-.08.84-.13,1.26Zm.25-5.19c0-.68-.07-1.38-.13-2.07l1-.1c.07.71.12,1.43.14,2.14Zm26.25-7.18c-.11.7-.21,1.39-.29,2.08l-1-.12c.09-.71.19-1.41.3-2.11Zm-.57-3.27c.05-.41.1-.81.13-1.22s.05-.57.07-.85l1,.07c0,.28,0,.58-.07.87s-.08.84-.13,1.26Zm.08,8.44a14.4,14.4,0,0,0,.16,2l-1,.15a14.92,14.92,0,0,1-.17-2.17Zm27,20.76c.64.31,1.28.63,1.9,1l-.5.9c-.61-.33-1.22-.65-1.85-.95Zm-4.92-2c.66.24,1.33.49,2,.75l-.38,1c-.65-.26-1.3-.5-2-.74Zm-5-1.76,2,.7-.35,1-2-.7Zm-4.87-1.92,1.92.81-.38,1c-.66-.27-1.31-.54-2-.83Zm-4.54-2.49c.56.38,1.15.74,1.75,1.09l-.5.9c-.63-.36-1.25-.74-1.83-1.14Zm-3.9-3.35c.45.49.94,1,1.46,1.45l-.69.77a20.24,20.24,0,0,1-1.54-1.53ZM397.05,147l-.88.54a14.3,14.3,0,0,1-1-1.95l.95-.39A14.54,14.54,0,0,0,397.05,147Zm-.7-20.41-1,0c0-.69-.07-1.39-.13-2.07l1-.11C396.28,125.18,396.33,125.9,396.35,126.61Zm-1.12-7.4c.19.68.36,1.38.5,2.08l-1,.21c-.14-.68-.3-1.36-.49-2Zm-27,36.71h1a14.4,14.4,0,0,0,.16,2l-1,.15A14.92,14.92,0,0,1,368.19,155.92Zm2.05,7.28a14.3,14.3,0,0,1-1-1.95l.95-.4a15.41,15.41,0,0,0,.92,1.81Zm3.48,4.13c-.54-.49-1.06-1-1.53-1.52l.77-.69c.45.49.94,1,1.45,1.44Zm4.39,3.12c-.63-.35-1.25-.73-1.83-1.13l.58-.85c.56.38,1.15.74,1.76,1.09Zm4.83,2.28c-.66-.27-1.31-.54-2-.83l.42-1c.64.29,1.28.56,1.92.82Zm5,1.82-2-.7.35-1,2,.71Zm4.94,1.8c-.65-.26-1.3-.5-2-.74l.36-1c.66.24,1.33.49,2,.75Zm4.72,2.2c-.61-.33-1.22-.65-1.85-1l.45-.93c.64.3,1.28.63,1.9,1Zm4.24,2.94c-.5-.44-1-.87-1.61-1.28l.6-.84c.59.43,1.17.88,1.69,1.34Zm3.33,3.86a15.66,15.66,0,0,0-1.18-1.66l.8-.66a16.43,16.43,0,0,1,1.26,1.78Zm24.75-17.3.8-.65a15.05,15.05,0,0,1,1.26,1.77l-.88.54A15.25,15.25,0,0,0,429.89,168.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,121.54h0a17.75,17.75,0,0,0-4.81-4.25c-2.63-1.52-5-1.69-6.76-.74l-.19.11,0,0c-1.67,1-2.7,3.14-2.71,6.12,0,6.14,4.3,13.62,9.64,16.7,2.65,1.53,5.06,1.69,6.81.71h0l.05,0,6.55-3.86C364,130.34,360.52,125.55,357.22,121.54Zm1.06,1.44-.07-.09Zm3.69,9.58c0-.13,0-.27-.05-.41C361.94,132.29,362,132.43,362,132.56Zm-.23-1.52c0-.12,0-.25-.07-.37C361.7,130.79,361.72,130.92,361.74,131Zm-1-3.36c0-.09-.07-.19-.11-.28C360.69,127.49,360.72,127.59,360.76,127.68Zm-.7-1.6a.77.77,0,0,0-.07-.16A.77.77,0,0,1,360.06,126.08Z",
    style: {
      fill: "#fff",
      opacity: 0.29
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.24 215.51 357.25 224.17 357.22 232.62 393.77 253.72 393.8 245.27 386.83 231.43 380.58 236.29 382.79 243.16 379.58 237.06 368.24 215.51",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.24,219.77c-1.72-1-3.12-.19-3.12,1.78a6.82,6.82,0,0,0,3.1,5.38c1.72,1,3.12.2,3.13-1.78A6.89,6.89,0,0,0,380.24,219.77Z",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--light-bulb--inject-77--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Idea--inject-77--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--light--inject-77--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.67,132.22a3.53,3.53,0,1,1-3.59-3.47,3.52,3.52,0,0,1,3.59,3.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.87,132.59c-2.36-1.31-2.4-3.5-.08-4.9a9.39,9.39,0,0,1,8.48-.12c2.36,1.32,2.4,3.51.08,4.89A9.39,9.39,0,0,1,140.87,132.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.72,131.32c-2.44-1.36-2.48-3.61-.09-5a9.73,9.73,0,0,1,8.75-.14c2.43,1.37,2.47,3.62.07,5.05A9.6,9.6,0,0,1,140.72,131.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.57,130c-2.5-1.4-2.54-3.72-.06-5.14a9.94,9.94,0,0,1,9-.14c2.51,1.39,2.56,3.73.09,5.2A10,10,0,0,1,140.57,130Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,128.65c-2.58-1.43-2.61-3.83-.08-5.35a10.25,10.25,0,0,1,9.28-.16c2.59,1.45,2.63,3.84.08,5.37A10.28,10.28,0,0,1,140.4,128.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.26,127.25c-2.67-1.53-2.69-3.92-.09-5.48a10.46,10.46,0,0,1,9.48-.14c2.64,1.46,2.68,3.91.08,5.46A10.47,10.47,0,0,1,140.26,127.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.36,86a16.8,16.8,0,0,0-16.58,17v.08c.21,13.36,11.25,15.42,11.36,20.79a2.91,2.91,0,0,0,1.74,2.35,9.1,9.1,0,0,0,8.21-.12,2.89,2.89,0,0,0,1.64-2.39h0c-.09-5.39,10.9-7.78,10.69-21.16A16.79,16.79,0,0,0,144.4,86Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000238418579
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.36,86a16.8,16.8,0,0,0-16.58,17v.08c.21,13.36,11.25,15.42,11.36,20.79a2.91,2.91,0,0,0,1.74,2.35,9.1,9.1,0,0,0,8.21-.12,2.89,2.89,0,0,0,1.64-2.39h0c-.09-5.39,10.9-7.78,10.69-21.16A16.79,16.79,0,0,0,144.4,86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.91,125.49c-1.68-1-1.76-2.55-.11-3.55a6.83,6.83,0,0,1,6.18-.09c1.68,1,1.75,2.55.06,3.56A6.82,6.82,0,0,1,141.91,125.49Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.2,123.2a.58.58,0,0,1-.58-.55,41.58,41.58,0,0,1,1-9.62,19.74,19.74,0,0,1,.8-2.69,7.72,7.72,0,0,1-1.48-.7,9.86,9.86,0,0,1-2.28-1.89,10,10,0,0,1-2.2,1.91,7.38,7.38,0,0,1-1.46.73,20.9,20.9,0,0,1,.89,2.67,40,40,0,0,1,1.33,9.61.57.57,0,1,1-1.14,0,40.57,40.57,0,0,0-1.3-9.3,18.75,18.75,0,0,0-.89-2.65,3.54,3.54,0,0,1-3.2-.89,1.83,1.83,0,0,1-.29-2.35,1.54,1.54,0,0,1,1.55-.68,4.34,4.34,0,0,1,2.57,2.58,6.44,6.44,0,0,0,1.31-.66,9,9,0,0,0,2.12-1.87,4.15,4.15,0,0,1-.89-3.2,1.52,1.52,0,0,1,1.52-1.15,1.48,1.48,0,0,1,1.54,1.1,4.15,4.15,0,0,1-.78,3.23,8.89,8.89,0,0,0,2.16,1.8,6.49,6.49,0,0,0,1.34.61,4.41,4.41,0,0,1,2.49-2.65,1.54,1.54,0,0,1,1.56.68,1.81,1.81,0,0,1-.21,2.35,3.57,3.57,0,0,1-3.17,1,19.28,19.28,0,0,0-.82,2.68,40.73,40.73,0,0,0-1,9.34.58.58,0,0,1-.55.6Zm-9.49-15.27a.36.36,0,0,0-.31.21c-.28.38,0,.8.16.91a2.24,2.24,0,0,0,1.83.56,3.24,3.24,0,0,0-1.59-1.69Zm12.37,1.56a2.33,2.33,0,0,0,1.83-.64c.09-.11.42-.53.14-.91a.39.39,0,0,0-.41-.2C151.25,107.82,150.67,108.36,150.08,109.49Zm-5.42-5.82a.39.39,0,0,0-.44.32h0a2.73,2.73,0,0,0,.48,1.86,2.79,2.79,0,0,0,.4-1.87.39.39,0,0,0-.44-.32h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.37,79.57a1,1,0,0,1-.29.05A1.11,1.11,0,0,1,143,78.54l-.12-5.73a1.1,1.1,0,0,1,1.06-1.13h0A1.1,1.1,0,0,1,145,72.76l.13,5.74A1.12,1.12,0,0,1,144.37,79.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.21,83.12a1.09,1.09,0,0,1-1.25-.48l-3-4.9a1.11,1.11,0,0,1,.47-1.49,1.09,1.09,0,0,1,1.41.35l3,4.89a1.09,1.09,0,0,1-.37,1.51A.68.68,0,0,1,132.21,83.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.46,92.28a1.1,1.1,0,0,1-.85-.09l-5-2.76a1.1,1.1,0,1,1,1-1.93l5,2.75a1.1,1.1,0,0,1,.43,1.49A1.07,1.07,0,0,1,123.46,92.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45,104.58a.79.79,0,0,1-.27.1l-5.73.13a1.08,1.08,0,0,1-1.12-1v0a1.09,1.09,0,0,1,1-1.13h0l5.74-.19a1.1,1.1,0,0,1,.33,2.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.11,103.36a.81.81,0,0,1-.27.11l-5.75.07a1.1,1.1,0,1,1,0-2.19l5.73-.14a1.11,1.11,0,0,1,1.09,1.12,1.1,1.1,0,0,1-.76,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.83,91.34a1.1,1.1,0,0,1-.88-2l4.9-3a1.08,1.08,0,0,1,1.49.34v0a1.08,1.08,0,0,1-.35,1.5h0l-4.9,3A1.23,1.23,0,0,1,165.83,91.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.68,82.58a1.11,1.11,0,0,1-1.37-.75,1.12,1.12,0,0,1,.09-.84l2.78-5a1.11,1.11,0,0,1,1.93,1.06l-2.76,5A1.14,1.14,0,0,1,156.68,82.58Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.44,376.41a9.65,9.65,0,0,0-4.39-7.59,3.83,3.83,0,0,0-.57-.29v-3.28L145.58,359a9.54,9.54,0,0,0,2.17-5.61,3.12,3.12,0,0,0-1.24-2.78h0l0,0,0,0-2.79-1.77h0v-2.65l-.69-.28L128.54,349V346a5.75,5.75,0,0,0,.66-.31,3.31,3.31,0,0,0,1.94-2.74V320H117.79v23a3.35,3.35,0,0,0,2,2.74c.19.11.41.19.62.29v3.52l-19.9-1.05L99,349v.71a2.53,2.53,0,0,0-2.08.2h0l-2.79,1.77,0,0,0,0h0a3.1,3.1,0,0,0-1.24,2.78,9.66,9.66,0,0,0,4.39,7.6,3.13,3.13,0,0,0,3.1.32h0l0,0,2.76-1.76h0a3,3,0,0,0,1.37-2.85,9,9,0,0,0-1.31-4.36l12.25,3.09-23.23,13.8v4.35a9.78,9.78,0,0,0-3.57,7A3,3,0,0,0,90,384.5h0l2.75,1.76.05,0h0a3.1,3.1,0,0,0,3.1-.32,9.64,9.64,0,0,0,4.38-7.6,3.09,3.09,0,0,0-1.23-2.78h0l0,0,0,0-1.43-.91,24.95-13.48h0a6.45,6.45,0,0,0,1.93.31h0l3,21.59a2.43,2.43,0,0,0-1.46.32h0l-2.79,1.76,0,0,0,0h0a3.12,3.12,0,0,0-1.24,2.79,9.65,9.65,0,0,0,4.39,7.59,3.13,3.13,0,0,0,3.1.33h0l.06,0,2.75-1.75h0a3,3,0,0,0,1.38-2.86,9.84,9.84,0,0,0-3.63-7.07v-2.81l-2.38-20.72a1.88,1.88,0,0,0,1-1.53l26.35,10.71-.81.51,0,0,0,0h0a3.12,3.12,0,0,0-1.24,2.78,9.68,9.68,0,0,0,4.39,7.6,3.13,3.13,0,0,0,3.1.33h0l.06,0,2.75-1.76h0A3,3,0,0,0,164.44,376.41ZM158.32,366l-13.61-6.06h0l10.07,4.49Zm-22-11.17-1.4-.63,2-1.09A9.42,9.42,0,0,0,136.34,354.82Zm-.21,1.28h0l-7.59-3.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.25,355.45l-2.2-3.77,2.86-1.82h0a3.06,3.06,0,0,1,3.18.26,9.69,9.69,0,0,1,4.39,7.6,3,3,0,0,1-1.37,2.85h0l-2.81,1.79-2.33-4A10.76,10.76,0,0,1,96.25,355.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.23,352c-2.43-1.4-4.41-.28-4.42,2.51a9.66,9.66,0,0,0,4.39,7.6c2.43,1.4,4.41.28,4.41-2.52A9.64,9.64,0,0,0,97.23,352Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,354.38l2.2-3.78-2.86-1.82h0a3.06,3.06,0,0,0-3.18.27,9.65,9.65,0,0,0-4.39,7.59,3,3,0,0,0,1.37,2.86h0l2.81,1.8,2.33-4A10.76,10.76,0,0,0,144.31,354.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33,350.87c2.43-1.4,4.41-.28,4.42,2.51a9.66,9.66,0,0,1-4.39,7.6c-2.43,1.4-4.41.28-4.41-2.51A9.64,9.64,0,0,1,143.33,350.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.54,345h-8.16v14.07h0a2.07,2.07,0,0,0,1.21,1.67,6.38,6.38,0,0,0,5.77,0,2,2,0,0,0,1.18-1.67h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.99 348.96 98.99 352.32 120.38 357.71 120.38 350.61 98.99 348.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.99 348.96 100.48 348.46 120.38 349.51 120.38 350.61 98.99 348.96",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.84,379.37l2.21-3.78-2.86-1.82h0a3,3,0,0,0-3.17.27,9.65,9.65,0,0,0-4.39,7.59A3,3,0,0,0,90,384.5h0l2.81,1.79,2.32-4A10.42,10.42,0,0,0,96.84,379.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.87,375.86c2.43-1.4,4.41-.28,4.41,2.51A9.64,9.64,0,0,1,95.9,386c-2.43,1.4-4.41.28-4.42-2.52A9.65,9.65,0,0,1,95.87,375.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,389l-2.2-3.78,2.86-1.81h0a3.08,3.08,0,0,1,3.18.27,9.68,9.68,0,0,1,4.39,7.59,3,3,0,0,1-1.38,2.86h0l-2.81,1.79-2.33-4A10.51,10.51,0,0,1,125.33,389Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.31,385.45c-2.43-1.41-4.41-.28-4.42,2.51a9.65,9.65,0,0,0,4.39,7.59c2.43,1.41,4.41.28,4.41-2.51A9.64,9.64,0,0,0,126.31,385.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.21,374.14l-2.2-3.78,2.86-1.82h0a3,3,0,0,1,3.18.27,9.65,9.65,0,0,1,4.39,7.59,3,3,0,0,1-1.37,2.86h0l-2.81,1.8-2.32-4A10.69,10.69,0,0,1,156.21,374.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.19,370.63c-2.43-1.4-4.41-.28-4.42,2.51a9.68,9.68,0,0,0,4.39,7.6c2.43,1.4,4.41.28,4.42-2.52A9.68,9.68,0,0,0,157.19,370.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.85 371.19 93.85 376.62 122.49 361.15 122.49 353.66 93.85 371.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.19 370.26 120.85 353.24 122.49 353.66 93.85 371.19 92.19 370.26",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.19 375.69 93.85 376.62 93.85 371.19 92.19 370.26 92.19 375.69",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.42 353.66 127.91 381.35 127.91 386.3 124.42 361.45 124.42 353.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.91,
    y: 381.34,
    width: 2.02,
    height: 4.95,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.93 381.35 126.75 353.66 124.42 353.66 127.91 381.35 129.93 381.35",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.32 365.99 158.32 371.19 128.54 359.09 128.54 352.73 158.32 365.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.48 370.43 158.32 371.19 158.32 365.99 159.48 365.25 159.48 370.43",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.78 364.42 158.32 365.99 159.48 365.25 128.54 351.31 128.54 352.73 154.78 364.42",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.62 346.13 143.62 349.54 134.94 354.19 128.54 351.31 128.54 349.91 143.62 346.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.62 346.13 142.93 345.86 128.54 348.96 128.54 349.91 143.62 346.13",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.14,320H117.79v23h0a3.35,3.35,0,0,0,2,2.74,10.4,10.4,0,0,0,9.44,0,3.31,3.31,0,0,0,1.94-2.74h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75,283a7.46,7.46,0,0,0-2.54-2.46l-5-2.56c0-17.8,2.63-16.06,7.54-23s-2.62-11.33-8.28-8.23h0s-31.66,9.31-40,1.09c-10.41-10.22-6.05-36-4.81-46.09s0-17.07-2.79-20-6.83-7.3-19.94-1.87c0,0-35.33,15.31-52.63,23.85a23.26,23.26,0,0,0-10.89,5.54,7.23,7.23,0,0,0-2,2.63,3.14,3.14,0,0,0,.39,3.15,3.09,3.09,0,0,0,2.08.93l21.83,80.65a19.31,19.31,0,0,0,9.91,12.18L114.71,328a12.75,12.75,0,0,0,11.73-.11L180.86,299C186.29,295.9,186.8,287.59,183.75,283Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75,283a8.57,8.57,0,0,1-2.89,2.72l-54.42,28.91a12.72,12.72,0,0,1-11.73.12L76.58,295.39a19.33,19.33,0,0,1-9.91-12.18l-18.4-68-.92.28a7.3,7.3,0,0,1-2.41.36h-.1l21.83,80.65a19.31,19.31,0,0,0,9.91,12.18L114.71,328a12.75,12.75,0,0,0,11.73-.11L180.86,299C186.29,295.9,186.8,287.59,183.75,283Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.21,280.49l-39.44-20.23L89.84,287c1.69.41,3.4.75,5.11,1.09,4.46.9,9,1.89,12.89,4.27s7,6.47,7,11l-1.39,10.71h0l1.21.62a12.72,12.72,0,0,0,11.73-.12l54.42-28.91a8.57,8.57,0,0,0,2.89-2.72A7.46,7.46,0,0,0,181.21,280.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.21,280.49l-39.44-20.23L89.84,287c1.69.41,3.4.75,5.11,1.09,4.46.9,9,1.89,12.89,4.27s7,6.47,7,11l-1.39,10.71h0l1.21.62a12.72,12.72,0,0,0,11.73-.12l54.42-28.91a8.57,8.57,0,0,0,2.89-2.72A7.46,7.46,0,0,0,181.21,280.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.47,246.66s-31.66,9.31-40,1.09c-10.41-10.22-6.05-36-4.81-46.09s0-17.07-2.79-20-6.83-7.3-19.94-1.87c13.27,6.83,15,39.28,10.79,52.31,10.39,10.69,9.68,27.27,9.88,35,0,0,27.05,6.6,41.17,14.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.47,246.66s-31.66,9.31-40,1.09c-10.41-10.22-6.05-36-4.81-46.09s0-17.07-2.79-20-6.83-7.3-19.94-1.87c13.27,6.83,15,39.28,10.79,52.31,10.39,10.69,9.68,27.27,9.88,35,0,0,27.05,6.6,41.17,14.36Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.73,281.42l6.48-3.49c0-17.8,2.63-16.06,7.54-23s-2.62-11.33-8.28-8.23S167.52,259.11,169.73,281.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.73,281.42l6.48-3.49c0-17.8,2.63-16.06,7.54-23s-2.62-11.33-8.28-8.23S167.52,259.11,169.73,281.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89,179.78s-35.46,15.37-52.72,23.9l1.26,6.3L113,184.3A15.08,15.08,0,0,0,107.89,179.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89,179.78s-35.46,15.37-52.72,23.9l1.26,6.3L113,184.3A15.08,15.08,0,0,0,107.89,179.78Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.68,232.09c3.57-11.12,2.84-36.39-5.7-47.79L56.43,210l12.92,64.79L89.84,287l38.72-19.92C128.36,259.36,129.07,242.78,118.68,232.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.67,245.08c1-.56,1.74-.11,1.75,1a3.83,3.83,0,0,1-1.74,3c-1,.55-1.74.11-1.74-1A3.81,3.81,0,0,1,83.67,245.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.42,239.93c1-.55,1.75-.11,1.75,1a3.84,3.84,0,0,1-1.73,3c-1,.55-1.74.11-1.75-1A3.86,3.86,0,0,1,92.42,239.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.18,234.79c1-.55,1.74-.11,1.74,1a3.81,3.81,0,0,1-1.73,3c-1,.56-1.74.11-1.74-1A3.79,3.79,0,0,1,101.18,234.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.93,229.65c1-.56,1.74-.11,1.74,1a3.79,3.79,0,0,1-1.73,3c-1,.55-1.74.11-1.74-1A3.78,3.78,0,0,1,109.93,229.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.67,245.08c1-.56,1.74-.11,1.75,1a3.83,3.83,0,0,1-1.74,3c-1,.55-1.74.11-1.74-1A3.81,3.81,0,0,1,83.67,245.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.42,239.93c1-.55,1.75-.11,1.75,1a3.84,3.84,0,0,1-1.73,3c-1,.55-1.74.11-1.75-1A3.86,3.86,0,0,1,92.42,239.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.18,234.79c1-.55,1.74-.11,1.74,1a3.81,3.81,0,0,1-1.73,3c-1,.56-1.74.11-1.74-1A3.79,3.79,0,0,1,101.18,234.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.93,229.65c1-.56,1.74-.11,1.74,1a3.79,3.79,0,0,1-1.73,3c-1,.55-1.74.11-1.74-1A3.78,3.78,0,0,1,109.93,229.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.84,292.34C104,290,99.41,289,95,288.07c-1.71-.34-3.42-.68-5.11-1.09a31.88,31.88,0,0,1-7.91-2.88c-6.25-3.46-10.45-9.92-12.46-16.78s-2.06-14.13-1.64-21.26,1.31-14.26,1.09-21.41c-.12-4.15-.75-8.6-3.56-11.66s-7.58-4.14-11.82-3.57a23.86,23.86,0,0,0-4.11,1l-1.88,2.19.72,2.67,18.4,68a19.31,19.31,0,0,0,8.45,11.34c.48.29,1,.58,1.46.84l36.92,18.69,1.39-10.71C114.86,298.81,111.72,294.73,107.84,292.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89,285c-13.5-3.85-26.77-4.35-31.65-14.05s-5.24-23.08-2.8-46.36a35.53,35.53,0,0,0-.21-9c-1.44-8.71-6.68-12.43-12.71-12.52a23.46,23.46,0,0,0-16.15,6.07,7.23,7.23,0,0,0-2,2.63,3.14,3.14,0,0,0,.39,3.15,3.09,3.09,0,0,0,2.08.93h.1a7.3,7.3,0,0,0,2.41-.36l.92-.28c1.65-.53,3.28-1.14,5-1.56a10.84,10.84,0,0,1,6.08,0,6.45,6.45,0,0,1,3.9,4.35c5.69,18.6-1.52,38.58,4.88,53.95,5.24,14,23.34,19.76,36.11,23.9h0a7.85,7.85,0,0,1-3.19-2.32,5.38,5.38,0,0,1,.5-6.47A7,7,0,0,1,107.89,285Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89,285c-13.5-3.85-26.77-4.35-31.65-14.05s-5.24-23.08-2.8-46.36a35.53,35.53,0,0,0-.21-9c-1.44-8.71-6.68-12.43-12.71-12.52a23.46,23.46,0,0,0-16.15,6.07,7.23,7.23,0,0,0-2,2.63,3.14,3.14,0,0,0,.39,3.15,3.09,3.09,0,0,0,2.08.93h.1a7.3,7.3,0,0,0,2.41-.36l.92-.28c1.65-.53,3.28-1.14,5-1.56a10.84,10.84,0,0,1,6.08,0,6.45,6.45,0,0,1,3.9,4.35c5.69,18.6-1.52,38.58,4.88,53.95,5.24,14,23.34,19.76,36.11,23.9h0a7.85,7.85,0,0,1-3.19-2.32,5.38,5.38,0,0,1,.5-6.47A7,7,0,0,1,107.89,285Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,294.6a19.89,19.89,0,0,0-3.45-6.06,10.36,10.36,0,0,0-5.92-3.5,7,7,0,0,0-6.38,2.07,5.38,5.38,0,0,0-.5,6.47,7.85,7.85,0,0,0,3.19,2.32,30.29,30.29,0,0,1,3,1.46,12.6,12.6,0,0,1,5.1,7.21,37.28,37.28,0,0,1,1.18,8.93l0,.58,6.32-3.5A38.55,38.55,0,0,0,117.26,294.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,294.6a19.89,19.89,0,0,0-3.45-6.06,10.36,10.36,0,0,0-5.92-3.5,7,7,0,0,0-6.38,2.07,5.38,5.38,0,0,0-.5,6.47,7.85,7.85,0,0,0,3.19,2.32,30.29,30.29,0,0,1,3,1.46,12.6,12.6,0,0,1,5.1,7.21,37.28,37.28,0,0,1,1.18,8.93l0,.58,6.32-3.5A38.55,38.55,0,0,0,117.26,294.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.33,316.19a30.6,30.6,0,0,1-14.74-13.54c-3.21-6-4.8-11.26-3.58-17.94l48.89-19.24c1.51,14.54,14.89,24.08,14.89,24.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.67,373.57c0,3.94-.13,9.7-.13,9.7l-2.64.15a6.38,6.38,0,0,0-5.65,4.2l-.06.16a2.48,2.48,0,0,1-3.07,1.53h0a2.53,2.53,0,0,1-1.51-1.3l-1.26-12.9Z",
    style: {
      fill: "#8c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,412.89c6.9,2.94,17.47,3.52,21.85-3.53v1.91c-4.38,7-14.95,6.47-21.85,3.52S189,407,182.83,404.44a16.7,16.7,0,0,1-6-3.81c0-.56-.12-1.26-.22-2.08a20.86,20.86,0,0,0,6.26,4C189,405.12,187.5,409.94,194.4,412.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.57,392.29a9.9,9.9,0,0,0,0-4.07,2.17,2.17,0,0,1,.31-1.8l.55-.56.21,2.15a2.53,2.53,0,0,0,1.51,1.3,2.48,2.48,0,0,0,3.07-1.53l.06-.16a6.38,6.38,0,0,1,5.65-4.2l2.68-.15a1.93,1.93,0,0,1,1.89,1.18c2.75,6.65,9.68,14,15,17.4,3.92-.09,8.77,3.17,8.77,7.12v.39c-4.38,7.05-14.95,6.47-21.85,3.53s-5.39-7.77-11.57-10.36a20.86,20.86,0,0,1-6.26-4A22.77,22.77,0,0,1,176.57,392.29Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93,397.74a.87.87,0,0,1-1.36-1.1,10,10,0,0,1,9-4c.37.46.75.91,1.13,1.35A9.67,9.67,0,0,0,189.93,397.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,394.69a.86.86,0,0,1-1.22.11.85.85,0,0,1-.14-1.2,10.47,10.47,0,0,1,9.4-4.06c.33.49.68,1,1,1.47C192.91,390.77,189.9,391.41,187.21,394.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.76,400.72a.87.87,0,0,1-1.36-1.1,10,10,0,0,1,8.77-4c.45.47.9.92,1.35,1.36A9.66,9.66,0,0,0,192.76,400.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.48,401.85c3.92-.09,8.77,3.17,8.77,7.12v.39c-4.32,6.94-14.63,6.48-21.53,3.65C195.25,403.53,204.35,401.82,207.48,401.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.67,403.56a.87.87,0,0,1-1.36-1.09,10,10,0,0,1,8.79-4c.55.49,1.1.95,1.65,1.39C201.38,399.64,198.37,400.28,195.67,403.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.14,349.54c.55,8.72,2.78,15,4.48,26.93,0,0,10.44,3.11,16.95-1.43l.27-18.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.68,360.24c.87,3.82,2.62,8.9,2.62,8.9l-2.64.15a6.39,6.39,0,0,0-5.65,4.2l0,.16a2.49,2.49,0,0,1-3.08,1.53h0a2.48,2.48,0,0,1-1.5-1.3l-4-10.41Z",
    style: {
      fill: "#8c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.16,398.76c6.9,2.94,17.47,3.52,21.85-3.53v1.91c-4.38,7.05-14.95,6.47-21.85,3.52s-5.39-7.76-11.57-10.35a16.7,16.7,0,0,1-6-3.81c0-.56-.12-1.26-.22-2.08a21,21,0,0,0,6.26,4C228.77,391,227.26,395.81,234.16,398.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.33,378.16a9.9,9.9,0,0,0,0-4.07,2.18,2.18,0,0,1,.31-1.8l.1-.15.67,1.74a2.48,2.48,0,0,0,4.58-.23l0-.16a6.39,6.39,0,0,1,5.65-4.2l2.68-.15a1.94,1.94,0,0,1,1.89,1.19c2.75,6.64,9.68,14,15,17.39,3.92-.09,8.77,3.17,8.77,7.12v.39c-4.38,7-14.95,6.47-21.85,3.53s-5.39-7.77-11.57-10.35a21,21,0,0,1-6.26-4A22.77,22.77,0,0,1,216.33,378.16Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.69,383.61a.87.87,0,0,1-1.36-1.1,10,10,0,0,1,9-3.95c.37.45.75.9,1.13,1.34A9.69,9.69,0,0,0,229.69,383.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,380.57a.87.87,0,0,1-1.36-1.1,10.48,10.48,0,0,1,9.4-4.06c.33.49.68,1,1,1.47C232.68,376.64,229.67,377.28,227,380.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.52,386.59a.87.87,0,0,1-1.36-1.1,10,10,0,0,1,8.77-4c.45.47.9.92,1.35,1.36A9.66,9.66,0,0,0,232.52,386.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.24,387.72c3.92-.09,8.77,3.17,8.77,7.12v.39c-4.32,6.95-14.63,6.48-21.53,3.65C235,389.4,244.11,387.69,247.24,387.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.43,389.43a.87.87,0,0,1-1.36-1.09,10,10,0,0,1,8.8-4c.55.49,1.09.95,1.64,1.39C241.14,385.51,238.13,386.15,235.43,389.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,339.75c2,8.5,5.28,14.35,9,25.78,0,0,10.82,1.31,16.46-4.28l-4.86-29.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.91,237.88l12.57,10.21,8.28-13.44L187.34,222.9C178.17,227,176.91,237.88,176.91,237.88Z",
    style: {
      fill: "#734242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,203.16c9.88-1.11,10.79,1.08,17.19,7.12s12.88,12.84,12.88,12.84c-9.88,4.83-11,16.57-11,16.57-5.38-4.17-9.93-7.46-9.93-7.46Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,203.16c9.88-1.11,10.79,1.08,17.19,7.12s12.88,12.84,12.88,12.84c-9.88,4.83-11,16.57-11,16.57-5.38-4.17-9.93-7.46-9.93-7.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39,211c14-6.59,24.59-7.36,36.08-7.85,17.19,11.07,10.75,20.29,10.46,35.07s-3.51,23.71,6.73,39.08c-22.53,18-51,12.31-57.81,8C113.46,244.38,114.75,214.16,122.39,211Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39,211c14-6.59,24.59-7.36,36.08-7.85,17.19,11.07,10.75,20.29,10.46,35.07s-3.51,23.71,6.73,39.08c-22.53,18-51,12.31-57.81,8C113.46,244.38,114.75,214.16,122.39,211Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.15,181.47c-1.77-5.93-1.39-12.75,2.16-17.82a19.36,19.36,0,0,1,9.41-6.94,29.7,29.7,0,0,1,11.7-1.52,21.69,21.69,0,0,1,9,2.17,14.53,14.53,0,0,1,6,19.69,24.4,24.4,0,0,1-5.91,6.75,74.73,74.73,0,0,1-14.89,9.93c-1.33.68-2.68,1.32-4.05,1.91-.94.41-2.7,1.55-3.74,1.35s-2.15-2.17-2.78-3c-.91-1.16-1.78-2.35-2.59-3.57A34.39,34.39,0,0,1,128.15,181.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.07,166.28a14.86,14.86,0,0,1-9.86,4.15c-3.46,0-6.82-1.11-10.16-2a7.68,7.68,0,0,1-2.29,4.24,8.87,8.87,0,0,1-4.73,2.07,30.19,30.19,0,0,1,0,9.44,1.77,1.77,0,0,1-1.19,1.45c-1.13.33-1.88-.83-2.42-1.76a7.8,7.8,0,0,0-2.44-2.72,3.81,3.81,0,0,0-3.53-.37,3.71,3.71,0,0,0-1.86,2.27,6.71,6.71,0,0,0-.14,3,8.88,8.88,0,0,0,1.94,4.57,6.17,6.17,0,0,0,4.34,2.25,4.5,4.5,0,0,0,4.18-2.07l.07.31a14.56,14.56,0,0,0,.46,1.46,12.46,12.46,0,0,0,9.13,7.81c2.11.44,4.46.87,6.86,1.23,1.18.18,2.36.35,3.55.49a8.55,8.55,0,0,0,9.44-7C168,186,168.53,175.32,165.07,166.28Z",
    style: {
      fill: "#8c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.4,192.53v15.89a17.51,17.51,0,0,0,12.79,7.09,6.23,6.23,0,0,0,4.6-1.18,3.73,3.73,0,0,0-.47-5.89,2.05,2.05,0,0,1-.93-1.7v-5.17c-2.4-.36-4.75-.79-6.86-1.23A12.46,12.46,0,0,1,137.4,192.53Z",
    style: {
      fill: "#8c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,203.84a34.91,34.91,0,0,0,5.37.95v-3.22c-2.4-.36-4.75-.79-6.86-1.23a12.48,12.48,0,0,1-8.82-7.13,12.79,12.79,0,0,0,3.22,6.66A15.29,15.29,0,0,0,148,203.84Z",
    style: {
      fill: "#734242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.16,177.81H156.1a15,15,0,0,0-14.21-1.45v2.16l.57.31a22.26,22.26,0,0,1,.53,4.25,5.66,5.66,0,0,0,1.57,3.77c1.13,1,2.74,1.07,4.23,1.09a7.79,7.79,0,0,0,3.52-.51,5.63,5.63,0,0,0,2.68-3.21c.5-1.36.42-2.14,1-3.77a1.19,1.19,0,0,1,1.12-.75,1.11,1.11,0,0,1,1.05.75c.59,1.63.52,2.41,1,3.77a5.56,5.56,0,0,0,2.51,3.21,6.81,6.81,0,0,0,3.29.51,5.74,5.74,0,0,0,4-1.09,5.87,5.87,0,0,0,1.46-3.77,24,24,0,0,1,.5-4.25l.53-.31v-2.16A13.29,13.29,0,0,0,158.16,177.81Zm-3.1,1.11-.08.77a18.27,18.27,0,0,1-1,4.09,4.62,4.62,0,0,1-2.13,2.59,5.89,5.89,0,0,1-2.52.41h-.47a5.47,5.47,0,0,1-3.49-.84,4.42,4.42,0,0,1-1.2-3q-.06-.54-.09-1.11c-.07-1,0-3.3.08-4.94a13.37,13.37,0,0,1,3.6-.5,13.78,13.78,0,0,1,7.25,2.11C155.1,178.56,155.06,178.92,155.06,178.92Zm14.37,2.89c0,.38,0,.75-.08,1.11a4.56,4.56,0,0,1-1.12,3,4.88,4.88,0,0,1-3.27.84h-.44a5.21,5.21,0,0,1-2.36-.41,4.6,4.6,0,0,1-2-2.59,18.93,18.93,0,0,1-1-4.09l-.08-.77s0-.36.08-.44a12.28,12.28,0,0,1,6.78-2.11,11.81,11.81,0,0,1,3.37.5C169.44,178.51,169.5,180.78,169.43,181.81Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,176.36l-11.56,4.16a5,5,0,0,1,2.26,1.06c.13.11,9.3-3.06,9.3-3.06Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.11 179.87 162.95 186.94 157.6 188.83 157.11 179.87",
    style: {
      fill: "#734242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.87,180.76a1.61,1.61,0,1,0,1.61-1.6A1.61,1.61,0,0,0,148.87,180.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.33,180.32a1.61,1.61,0,1,0,1.61-1.59A1.61,1.61,0,0,0,162.33,180.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,173.21l4.3.49a2.29,2.29,0,0,0-1.8-1.89A2.71,2.71,0,0,0,161.48,173.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.87,173.7l4.32,0a2.27,2.27,0,0,1-2,1.66A2.71,2.71,0,0,1,148.87,173.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.93,
    cy: 192.53,
    r: 1.54,
    style: {
      fill: "#734242"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.93,
    cy: 192.53,
    r: 1.54,
    style: {
      fill: "#734242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.7,214.3l-4,1.86a1.62,1.62,0,0,0-.77,2.2h0a1.62,1.62,0,0,0,1.73.87l10-1.79-3.05-3.87Z",
    style: {
      fill: "#734242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,217.86l12.6,29.68a8.74,8.74,0,0,0,11.17,4.75h0a8.74,8.74,0,0,0,3.68-13.63L182.5,213a12.37,12.37,0,0,0-2.47-2.32l-6.28-4.43a13.39,13.39,0,0,0-5.95-2.34h0l-3.06-2.25a3.09,3.09,0,0,0-2.91-.39l-4.72,1.82h0a3.08,3.08,0,0,0,3.55,1.71l1.88-.46,2.2,1.62-2.86,4a2.49,2.49,0,0,0,.5,3.42l5.4,4.15a1.94,1.94,0,0,0,1.74.32h0a1.93,1.93,0,0,0,1.32-2.24v0A6.81,6.81,0,0,0,175.64,217.86Z",
    style: {
      fill: "#8c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.74,206a7.25,7.25,0,0,1,2-1.62l-3.79.28Z",
    style: {
      fill: "#734242"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.76 278.34 334.76 368.41 331.57 366.57 331.57 276.5 334.76 278.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.76 278.34 334.76 368.41 337.94 366.57 337.94 276.5 334.76 278.34",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.57 302.36 257.03 259.32 257.03 255.9 331.57 298.94 331.57 302.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.57 295.32 260.22 254.06 257.03 255.9 331.57 298.94 331.57 295.32",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.77 318.58 109.77 408.65 106.59 406.8 106.59 316.74 109.77 318.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.77 318.58 109.77 408.65 112.96 406.8 112.96 316.74 109.77 318.58",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 363.47 187.5 453.54 184.32 451.69 184.32 361.63 187.5 363.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 363.47 187.5 453.54 190.69 451.69 190.69 361.63 187.5 363.47",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.32 387.49 109.77 344.45 109.77 341.03 184.32 384.06 184.32 387.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.32 380.45 112.96 339.19 109.77 341.03 184.32 384.06 184.32 380.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "109.77 318.58 109.77 408.65 106.59 406.8 106.59 316.74 109.77 318.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.77 318.58 109.77 408.65 112.96 406.8 112.96 316.74 109.77 318.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 363.47 187.5 453.54 184.32 451.69 184.32 361.63 187.5 363.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 363.47 187.5 453.54 190.69 451.69 190.69 361.63 187.5 363.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.32 387.49 109.77 344.45 109.77 341.03 184.32 384.06 184.32 387.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.32 380.45 112.96 339.19 109.77 341.03 184.32 384.06 184.32 380.45",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "334.76 278.34 334.76 368.41 331.57 366.57 331.57 276.5 334.76 278.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.76 278.34 334.76 368.41 337.94 366.57 337.94 276.5 334.76 278.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.57 302.36 257.03 259.32 257.03 255.9 331.57 298.94 331.57 302.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.57 295.32 260.22 254.06 257.03 255.9 331.57 298.94 331.57 295.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 354.77 337.95 268.06 257.04 221.33 106.59 308.04 187.5 354.77",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 363.47 337.95 276.5 337.95 268.06 187.5 354.77 187.5 363.47",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 354.76 106.59 308.03 106.59 316.74 187.5 363.47 187.5 354.76",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 354.77 337.95 268.06 257.04 221.33 106.59 308.04 187.5 354.77",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 354.76 106.59 308.03 106.59 316.74 187.5 363.47 187.5 354.76",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.5 363.47 337.95 276.5 337.95 268.06 187.5 354.77 187.5 363.47",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 221.33 106.6 308.03 106.59 308.03 106.59 316.73 187.5 363.47 337.95 276.5 337.95 268.06 257.04 221.33",
    style: {
      fill: "#fff",
      opacity: 0.32
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.49 241.96 261.55 268.34 293.05 263.46 280.98 237.08 249.49 241.96",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.66 247.07 264.93 269.31 291.51 258.35 264.25 236.12 237.66 247.07",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.08 239.64 215.75 255.99 256.53 269.62 272.88 253.26 232.08 239.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.37,284.19l-33-19.18a7.44,7.44,0,0,0-6.78,0l-54.46,31.44a2.46,2.46,0,0,0-1.4,1.87h0v2.09h0a1.58,1.58,0,0,0,.05.43.09.09,0,0,0,0,.05,1.8,1.8,0,0,0,.23.46l0,0a2.46,2.46,0,0,0,.41.45l0,0a3.28,3.28,0,0,0,.61.43l33,19.19a5.46,5.46,0,0,0,1,.42l.36.11.48.12.59.1.14,0a7.09,7.09,0,0,0,.81,0h.12c.27,0,.54,0,.8,0l.12,0a6.51,6.51,0,0,0,.77-.13l.14,0a6.37,6.37,0,0,0,.66-.21l.12,0a4.91,4.91,0,0,0,.73-.34l54.47-31.45a4.23,4.23,0,0,0,.62-.43l.15-.17a4.2,4.2,0,0,0,.29-.32,1.28,1.28,0,0,0,.11-.2,2.89,2.89,0,0,0,.15-.31.93.93,0,0,0,0-.23,1.57,1.57,0,0,0,0-.3v-1.94A2.39,2.39,0,0,0,256.37,284.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.72,298.32a1.67,1.67,0,0,0,.06.59.09.09,0,0,0,0,0,2,2,0,0,0,.23.46l0,.05a2.46,2.46,0,0,0,.41.45l0,0a3.28,3.28,0,0,0,.61.43l33,19.19a4.78,4.78,0,0,0,1,.41c.11,0,.24.08.36.12l.48.12.59.1.14,0c.26,0,.53,0,.81,0h.12c.27,0,.54,0,.8,0l.12,0a6.51,6.51,0,0,0,.77-.13l.14,0A6.37,6.37,0,0,0,201,320l.12,0a4.91,4.91,0,0,0,.73-.34l54.47-31.45a4.23,4.23,0,0,0,.62-.43l.15-.17a4.2,4.2,0,0,0,.29-.32c.05-.07.07-.14.11-.2a2.89,2.89,0,0,0,.15-.31.93.93,0,0,0,0-.23,1.54,1.54,0,0,0,0-.31v1.94a1.57,1.57,0,0,1,0,.3.93.93,0,0,1,0,.23,2.89,2.89,0,0,1-.15.31,1.28,1.28,0,0,1-.11.2,4.2,4.2,0,0,1-.29.32l-.15.17a4.23,4.23,0,0,1-.62.43L201.89,321.5a4.91,4.91,0,0,1-.73.34l-.12,0a6.37,6.37,0,0,1-.66.21l-.14,0a6.51,6.51,0,0,1-.77.13l-.12,0c-.26,0-.53,0-.8,0h-.12a7.09,7.09,0,0,1-.81,0l-.14,0-.59-.1-.48-.12-.36-.11a5.46,5.46,0,0,1-1-.42l-33-19.19a3.28,3.28,0,0,1-.61-.43l0,0a2.46,2.46,0,0,1-.41-.45l0,0a1.8,1.8,0,0,1-.23-.46.09.09,0,0,1,0-.05,1.58,1.58,0,0,1-.05-.43h0v-2.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.15,286.15,200.24,316.7a1.39,1.39,0,0,1-.21.1l-.12,0a2.76,2.76,0,0,1-.41.12,2.34,2.34,0,0,1-.29.06l-.2,0a3.64,3.64,0,0,1-.52,0h-.05a3.81,3.81,0,0,1-.54,0l-.34-.06c-.08,0-.43-.11-.43-.11s-.25-.09-.37-.15l-17-9.9,54.66-31.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.43,317.07h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.81,277.75l9.95,5.86a1,1,0,0,1,0,1.74l-14.89,8.59a1.64,1.64,0,0,1-1.66,0l-10-5.85a1,1,0,0,1,0-1.74l14.88-8.6A1.69,1.69,0,0,1,202.81,277.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.26,245.74h0l-1.3-.65h0a1.59,1.59,0,0,0-1.45.09l-54.85,31.89a6.61,6.61,0,0,0-3.21,4.69l-5.64,35.85a1.64,1.64,0,0,0,.92,1.74h0L201,320h0a1.61,1.61,0,0,0,1.41-.12L257.24,288a6.63,6.63,0,0,0,3.21-4.7l5.64-35.85A1.63,1.63,0,0,0,265.26,245.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.36,278.54a12.16,12.16,0,0,0-5.45,7.84c-.35,2.8,1.49,3.84,4.15,2.31a12.12,12.12,0,0,0,5.44-7.84C239.86,278.05,238,277,235.36,278.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.93,318.17l5.64-35.86a6.55,6.55,0,0,1,3.21-4.69l54.84-31.89a1.6,1.6,0,0,1,1.64,0h0l-1.3-.65h0a1.59,1.59,0,0,0-1.45.09l-54.85,31.89a6.61,6.61,0,0,0-3.21,4.69l-5.64,35.85a1.64,1.64,0,0,0,.92,1.74h0L201,320h0A1.64,1.64,0,0,1,199.93,318.17Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,249.5l4.17,18.59L169.41,280a12,12,0,0,0,5.54.87l11.14-.92a6.21,6.21,0,0,1,3.74.88l6.38,3.87a6.55,6.55,0,0,1,1.7,1.45l3.12,3.7a2.33,2.33,0,0,1-.43,3.41l-2,1.41a7,7,0,0,1-7.21.56l-4.94-2.49-8.09,1.46a16.19,16.19,0,0,1-10.7-1.76L166,291.5l-35.31-7.45a12.14,12.14,0,0,1-9.31-9.15l-4.71-20.57Z",
    style: {
      fill: "#8c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39,211c-16.83,6.29-13,21.25-6.79,44.94,10,2.77,21.87-5.94,21.87-5.94C134.17,231.28,132.93,210.72,122.39,211Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39,211c-16.83,6.29-13,21.25-6.79,44.94,10,2.77,21.87-5.94,21.87-5.94C134.17,231.28,132.93,210.72,122.39,211Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.29,372.08l-17.44.51-17.43-.51c-.75,11.77,1.54,23.77,4.71,29.63h0a7.81,7.81,0,0,0,3.45,3.51c5.14,3,13.46,3,18.57,0a7.75,7.75,0,0,0,3.45-3.6C403.76,395.73,406,383.79,405.29,372.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.14,364.94c6.83,3.94,6.87,10.34.08,14.28s-17.83,3.94-24.66,0-6.86-10.34-.08-14.28S393.31,361,400.14,364.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.44,366.51c5.33,3.07,5.36,8.06.06,11.14s-13.91,3.08-19.23,0-5.36-8.07-.07-11.14S392.11,363.43,397.44,366.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M397.44,366.51c5.33,3.07,5.36,8.06.06,11.14s-13.91,3.08-19.23,0-5.36-8.07-.07-11.14S392.11,363.43,397.44,366.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M416.52,297.68c-39.29,12.86-39.65,39.15-30.79,57.87,2.23,3.79,9,5.82,14.88-17.46l-10.32,1.32,12-6.09,3.12-9.34-10,.74,12.73-5.35A187.54,187.54,0,0,1,416.52,297.68Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.52,297.68c-39.29,12.86-39.65,39.15-30.79,57.87,2.23,3.79,9,5.82,14.88-17.46l-10.32,1.32,12-6.09,3.12-9.34-10,.74,12.73-5.35A187.54,187.54,0,0,1,416.52,297.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41,304.25C384.69,320,382.81,338,388.67,356.83,386.6,340.25,384.36,323.5,405.41,304.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,324.38c38.73,5.45,43.43,29.87,38.29,48.78-1.45,3.9-7.41,6.92-16.76-13.79l9.83-.48-12.21-3.68L364.66,347l9.46-1-12.74-2.87A179.22,179.22,0,0,0,350,324.38Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,324.38c38.73,5.45,43.43,29.87,38.29,48.78-1.45,3.9-7.41,6.92-16.76-13.79l9.83-.48-12.21-3.68L364.66,347l9.46-1-12.74-2.87A179.22,179.22,0,0,0,350,324.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.41,328.65c21.91,11.21,26.65,27.69,24.32,46.19C384.91,359.06,384.21,343.08,361.41,328.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.86,333.53c-35.52.58-42.49,22.07-40,39.68.88,3.68,5.91,7.07,16.65-10.55l-8.81-1.53,11.42-1.95,4.94-6.87-8.42-1.94,11.81-1.16A161.71,161.71,0,0,1,427.86,333.53Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.06,336.1c-21,7.65-27.11,22-27.09,38.91C392.48,360.88,394.9,346.56,417.06,336.1Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ5);
export default __webpack_public_path__ + "static/media/j5.e6ea042f6ec3a547cd8075e67701aac5.svg";
export { ForwardRef as ReactComponent };